import { notifications } from '@mantine/notifications';
import { refreshDataFile } from '../../apiClient';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useRefreshDataFile = () => {
    const entityUpdater = useEntityQueryUpdate();
    const mutation = useMutation({
        mutationKey: 'refresh_data_file',
        mutationFn: (model) => refreshDataFile(model),
        onSuccess: (data) => {
            entityUpdater([['data_files'], ['data_file', data.id]], data);
            notifications.show({
                title: 'Success',
                message: 'Successfully refreshed data file.',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useRefreshDataFile;
